export default function fireBaseErrorMessages (errCode) {
  switch (errCode) {
    case 'auth/email-already-in-use':
      return 'Este e-mail já está sendo usado por outra conta.'
    case 'auth/invalid-email':
      return 'E-mail inválido.'
    case 'auth/user-disabled':
      return 'Este usuário foi desativado'
    case 'auth/operationNotAllowed':
      return 'Operação não permitida'
    case 'auth/wrong-password':
      return 'Senha incorreta'
    case 'auth/user-not-found':
      return 'Não encontramos uma conta com o e-mail fornecido'
    case 'auth/internal-error':
      return 'Erro interno'
    case 'auth/too-many-requests':
      return 'Você já fez tentativas demais de login, aguarde alguns minutos.'
    case 'auth/operation-not-allowed':
      return 'A operação não é permitida.'
    case 'auth/weak-password':
      return 'A senha não é forte o suficiente, certifique-se de usar letras maiúsculas, minúsculas, números e caracteres especiais.'
    default:
      return 'Uma falha inesperada ocorreu. Por favor, contate nosso suporte.'
  }
}
